import classNames from 'classnames';

interface CursorOverlayProps {
  visible: boolean;
  x: number;
  y: number;
}

const CursorOverlay = ({ visible, x, y }: CursorOverlayProps) => {
  if (!visible) return null;

  const cursorOverlayClass =
    'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white';

  return (
    <div
      className="pointer-events-none absolute z-[1] translate-x-[-50%] translate-y-[-50%]"
      style={{
        left: `${x}px`,
        top: `${y}px`,
      }}
    >
      <div className="relative w-6 h-6 rounded-full bg-navy-800">
        <div className={classNames('w-3 h-0.5', cursorOverlayClass)} />
        <div className={classNames('h-3 w-0.5', cursorOverlayClass)} />
      </div>
    </div>
  );
};

export default CursorOverlay;
